export const modelData = [
    { label: "Acura CSX", value: "CSX", query: "model" },
    { label: "Acura ILX", value: "ILX", query: "model" },
    { label: "Acura Integra", value: "Integra", query: "model" },
    { label: "Acura MDX", value: "MDX", query: "model" },
    { label: "Acura NSX", value: "NSX", query: "model" },
    { label: "Acura RDX", value: "RDX", query: "model" },
    { label: "Acura RL", value: "RL", query: "model" },
    { label: "Acura RLX", value: "RLX", query: "model" },
    { label: "Acura TL", value: "TL", query: "model" },
    { label: "Acura TLX", value: "TLX", query: "model" },
    { label: "Acura TSX", value: "TSX", query: "model" },
    { label: "Acura ZDX", value: "ZDX", query: "model" },

    { label: "Alfa Romeo 159", value: "159", query: "model" },
    { label: "Alfa Romeo 4C", value: "4C", query: "model" },
    { label: "Alfa Romeo Giulia", value: "Giulia", query: "model" },
    { label: "Alfa Romeo Giulietta", value: "Giulietta", query: "model" },
    { label: "Alfa Romeo Mito", value: "Mito", query: "model" },
    { label: "Alfa Romeo Stelvio", value: "Stelvio", query: "model" },
    { label: "Alfa Romeo Tonale", value: "Tonale", query: "model" },


    { label: "Aston Martin DB11", value: "DB11", query: "model" },
    { label: "Aston Martin DB9", value: "DB9", query: "model" },
    { label: "Aston Martin DBS", value: "DBS", query: "model" },
    { label: "Aston Martin DBX", value: "DBX", query: "model" },
    { label: "Aston Martin DBX707", value: "DBX707", query: "model" },
    { label: "Aston Martin One-77", value: "One-77", query: "model" },
    { label: "Aston Martin Rapide", value: "Rapide", query: "model" },
    { label: "Aston Martin V12 Vantage", value: "V12 Vantage", query: "model" }, 
    { label: "Aston Martin V8 Vantage", value: "V8 Vantage", query: "model" }, 
    { label: "Aston Martin Vanquish", value: "Vanquish", query: "model" },
    { label: "Aston Martin Vantage", value: "Vantage", query: "model" },
    { label: "Aston Martin Virage", value: "Virage", query: "model" },

    { "label": "Audi A1", "value": "A1", "query": "model" },
    { "label": "Audi A3", "value": "A3", "query": "model" },
    { "label": "Audi A3 e-tron", "value": "A3 e-tron", "query": "model" },
    { "label": "Audi A3 Quattro", "value": "A3 Quattro", "query": "model" },
    { "label": "Audi A3 Sportback e-tron", "value": "A3 Sportback e-tron", "query": "model" },
    { "label": "Audi A4", "value": "A4", "query": "model" },
    { "label": "Audi A4 allroad", "value": "A4 allroad", "query": "model" },
    { "label": "Audi A4 Quattro", "value": "A4 Quattro", "query": "model" },
    { "label": "Audi A5", "value": "A5", "query": "model" },
    { "label": "Audi A5 Quattro", "value": "A5 Quattro", "query": "model" },
    { "label": "Audi A5 Sportback", "value": "A5 Sportback", "query": "model" },
    { "label": "Audi A6", "value": "A6", "query": "model" },
    { "label": "Audi A6 allroad", "value": "A6 allroad", "query": "model" },
    { "label": "Audi A6 Quattro", "value": "A6 Quattro", "query": "model" },
    { "label": "Audi A7", "value": "A7", "query": "model" },
    { "label": "Audi A7 Quattro", "value": "A7 Quattro", "query": "model" },
    { "label": "Audi A7 Sportback", "value": "A7 Sportback", "query": "model" },
    { "label": "Audi A8", "value": "A8", "query": "model" },
    { "label": "Audi A8 Quattro", "value": "A8 Quattro", "query": "model" },
    { "label": "Audi allroad", "value": "allroad", "query": "model" },
    { "label": "Audi e-tron GT", "value": "e-tron GT", "query": "model" },
    { "label": "Audi e-tron", "value": "e-tron", "query": "model" },
    { "label": "Audi e-tron S", "value": "e-tron S", "query": "model" },
    { "label": "Audi e-tron S Sportback", "value": "e-tron S Sportback", "query": "model" },
    { "label": "Audi e-tron Sportback", "value": "e-tron Sportback", "query": "model" },
    { "label": "Audi Q2", "value": "Q2", "query": "model" },
    { "label": "Audi Q2 Quattro", "value": "Q2 Quattro", "query": "model" },
    { "label": "Audi Q3", "value": "Q3", "query": "model" },
    { "label": "Audi Q3 Quattro", "value": "Q3 Quattro", "query": "model" },
    { "label": "Audi Q4 e-tron", "value": "Q4 e-tron", "query": "model" },
    { "label": "Audi Q4 e-tron Sportback", "value": "Q4 e-tron Sportback", "query": "model" },
    { "label": "Audi Q5", "value": "Q5", "query": "model" },
    { "label": "Audi Q5 PHEV", "value": "Q5 PHEV", "query": "model" },
    { "label": "Audi Q5 Sportback", "value": "Q5 Sportback", "query": "model" },
    { "label": "Audi Q7", "value": "Q7", "query": "model" },
    { "label": "Audi Q8", "value": "Q8", "query": "model" },
    { "label": "Audi R8", "value": "R8", "query": "model" },
    { "label": "Audi RS e-tron GT", "value": "RS e-tron GT", "query": "model" },
    { "label": "Audi RS Q3", "value": "RS Q3", "query": "model" },
    { "label": "Audi RS Q8", "value": "RS Q8", "query": "model" },
    { "label": "Audi RS3", "value": "RS3", "query": "model" },
    { "label": "Audi RS5", "value": "RS5", "query": "model" },
    { "label": "Audi RS5 Sportback", "value": "RS5 Sportback", "query": "model" },
    { "label": "Audi RS6", "value": "RS6", "query": "model" },
    { "label": "Audi RS6 Avant", "value": "RS6 Avant", "query": "model" },
    { "label": "Audi RS7", "value": "RS7", "query": "model" },
    { "label": "Audi RS7 Sportback", "value": "RS7 Sportback", "query": "model" },
    { "label": "Audi S3", "value": "S3", "query": "model" },
    { "label": "Audi S4", "value": "S4", "query": "model" },
    { "label": "Audi S5", "value": "S5", "query": "model" },
    { "label": "Audi S5 Sportback", "value": "S5 Sportback", "query": "model" },
    { "label": "Audi S6", "value": "S6", "query": "model" },
    { "label": "Audi S7", "value": "S7", "query": "model" },
    { "label": "Audi S7 Sportback", "value": "S7 Sportback", "query": "model" },
    { "label": "Audi S8", "value": "S8", "query": "model" },
    { "label": "Audi SQ5", "value": "SQ5", "query": "model" },
    { "label": "Audi SQ5 Sportback", "value": "SQ5 Sportback", "query": "model" },
    { "label": "Audi SQ7", "value": "SQ7", "query": "model" },
    { "label": "Audi SQ8", "value": "SQ8", "query": "model" },
    { "label": "Audi TT", "value": "TT", "query": "model" },
    { "label": "Audi TT Quattro", "value": "TT Quattro", "query": "model" },
    { "label": "Audi TT RS", "value": "TT RS", "query": "model" },
    { "label": "Audi TT RS Quattro", "value": "TT RS Quattro", "query": "model" },
    { "label": "Audi TTS", "value": "TTS", "query": "model" },
    { "label": "Audi TTS Quattro", "value": "TTS Quattro", "query": "model" },

    { "label": "BMW 1 Series", "value": "1 Series", "query": "model" },
  { "label": "BMW 2 Series", "value": "2 Series", "query": "model" },
  { "label": "BMW 3 Series", "value": "3 Series", "query": "model" },
  { "label": "BMW 4 Series", "value": "4 Series", "query": "model" },
  { "label": "BMW 5 Series", "value": "5 Series", "query": "model" },
  { "label": "BMW 6 Series", "value": "6 Series", "query": "model" },
  { "label": "BMW 7 Series", "value": "7 Series", "query": "model" },
  { "label": "BMW 8 Series", "value": "8 Series", "query": "model" },
  { "label": "BMW ActiveHybrid 3", "value": "ActiveHybrid 3", "query": "model" },
  { "label": "BMW ActiveHybrid 5", "value": "ActiveHybrid 5", "query": "model" },
  { "label": "BMW ActiveHybrid 7", "value": "ActiveHybrid 7", "query": "model" },
  { "label": "BMW Alpina B6 Gran Coupe", "value": "Alpina B6 Gran Coupe", "query": "model" },
  { "label": "BMW Alpina B6 xDrive Gran Coupe", "value": "Alpina B6 xDrive Gran Coupe", "query": "model" },
  { "label": "BMW Alpina B7", "value": "Alpina B7", "query": "model" },
  { "label": "BMW Alpina B7 xDrive", "value": "Alpina B7 xDrive", "query": "model" },
  { "label": "BMW Alpina B7L", "value": "Alpina B7L", "query": "model" },
  { "label": "BMW Alpina B7L xDrive", "value": "Alpina B7L xDrive", "query": "model" },
  { "label": "BMW Alpina B8 Gran Coupe", "value": "Alpina B8 Gran Coupe", "query": "model" },
  { "label": "BMW Alpina XB7", "value": "Alpina XB7", "query": "model" },
  { "label": "BMW i3", "value": "i3", "query": "model" },
  { "label": "BMW i3s", "value": "i3s", "query": "model" },
  { "label": "BMW i4", "value": "i4", "query": "model" },
  { "label": "BMW i7", "value": "i7", "query": "model" },
  { "label": "BMW i8", "value": "i8", "query": "model" },
  { "label": "BMW iX", "value": "iX", "query": "model" },
  { "label": "BMW iX xDrive40", "value": "iX xDrive40", "query": "model" },
  { "label": "BMW iX xDrive50", "value": "iX xDrive50", "query": "model" },
  { "label": "BMW iX3", "value": "iX3", "query": "model" },
  { "label": "BMW M135i", "value": "M135i", "query": "model" },
  { "label": "BMW M140i", "value": "M140i", "query": "model" },
  { "label": "BMW M2", "value": "M2", "query": "model" },
  { "label": "BMW M235i", "value": "M235i", "query": "model" },
  { "label": "BMW M235i xDrive", "value": "M235i xDrive", "query": "model" },
  { "label": "BMW M235i xDrive Gran Coupe", "value": "M235i xDrive Gran Coupe", "query": "model" },
  { "label": "BMW M240i", "value": "M240i", "query": "model" },
  { "label": "BMW M240i xDrive", "value": "M240i xDrive", "query": "model" },
  { "label": "BMW M3", "value": "M3", "query": "model" },
  { "label": "BMW M340i", "value": "M340i", "query": "model" },
  { "label": "BMW M340i xDrive", "value": "M340i xDrive", "query": "model" },
  { "label": "BMW M4", "value": "M4", "query": "model" },
  { "label": "BMW M440i", "value": "M440i", "query": "model" },
  { "label": "BMW M440i Gran Coupe", "value": "M440i Gran Coupe", "query": "model" },
  { "label": "BMW M440i xDrive", "value": "M440i xDrive", "query": "model" },
  { "label": "BMW M440i xDrive Gran Coupe", "value": "M440i xDrive Gran Coupe", "query": "model" },
  { "label": "BMW M5", "value": "M5", "query": "model" },
  { "label": "BMW M550i xDrive", "value": "M550i xDrive", "query": "model" },
  { "label": "BMW M6", "value": "M6", "query": "model" },
  { "label": "BMW M6 Gran Coupe", "value": "M6 Gran Coupe", "query": "model" },
  { "label": "BMW M760i xDrive", "value": "M760i xDrive", "query": "model" },
  { "label": "BMW M760Li xDrive", "value": "M760Li xDrive", "query": "model" },
  { "label": "BMW M8", "value": "M8", "query": "model" },
  { "label": "BMW M8 Gran Coupe", "value": "M8 Gran Coupe", "query": "model" },
  { "label": "BMW M850i xDrive", "value": "M850i xDrive", "query": "model" },
  { "label": "BMW M850i xDrive Gran Coupe", "value": "M850i xDrive Gran Coupe", "query": "model" },
  { "label": "BMW X1", "value": "X1", "query": "model" },
  { "label": "BMW X2", "value": "X2", "query": "model" },
  { "label": "BMW X3", "value": "X3", "query": "model" },
  { "label": "BMW X4", "value": "X4", "query": "model" },
  { "label": "BMW X5", "value": "X5", "query": "model" },
  { "label": "BMW X6", "value": "X6", "query": "model" },
  { "label": "BMW X7", "value": "X7", "query": "model" },
  { "label": "BMW Z4", "value": "Z4", "query": "model" },

  { "label": "Bentley Azure", "value": "Azure", "query": "model" },
  { "label": "Bentley Bentayga", "value": "Bentayga", "query": "model" },
  { "label": "Bentley Continental", "value": "Continental", "query": "model" },
  { "label": "Bentley Flying Spur", "value": "Flying Spur", "query": "model" },
  { "label": "Bentley Mulsanne", "value": "Mulsanne", "query": "model" },

  { "label": "Bugatti Chiron", "value": "Chiron", "query": "model" },
  { "label": "Bugatti Divo", "value": "Divo", "query": "model" },
  { "label": "Bugatti Veyron 16.4", "value": "Veyron 16.4", "query": "model" },

  { "label": "Buick Allure", "value": "Allure", "query": "model" },
  { "label": "Buick Cascada", "value": "Cascada", "query": "model" },
  { "label": "Buick Enclave", "value": "Enclave", "query": "model" },
  { "label": "Buick Enclave Avenir", "value": "Enclave Avenir", "query": "model" },
  { "label": "Buick Encore", "value": "Encore", "query": "model" },
  { "label": "Buick Encore GX", "value": "Encore GX", "query": "model" },
  { "label": "Buick Envision", "value": "Envision", "query": "model" },
  { "label": "Buick LaCrosse", "value": "LaCrosse", "query": "model" },
  { "label": "Buick Lucerne", "value": "Lucerne", "query": "model" },
  { "label": "Buick Regal", "value": "Regal", "query": "model" },
  { "label": "Buick Regal Sportback", "value": "Regal Sportback", "query": "model" },
  { "label": "Buick Regal TourX", "value": "Regal TourX", "query": "model" },
  { "label": "Buick Verano", "value": "Verano", "query": "model" },

  { "label": "Cadillac ATS", "value": "ATS", "query": "model" },
  { "label": "Cadillac CT4", "value": "CT4", "query": "model" },
  { "label": "Cadillac CT5", "value": "CT5", "query": "model" },
  { "label": "Cadillac CT6", "value": "CT6", "query": "model" },
  { "label": "Cadillac CTS", "value": "CTS", "query": "model" },
  { "label": "Cadillac DTS", "value": "DTS", "query": "model" },
  { "label": "Cadillac ELR", "value": "ELR", "query": "model" },
  { "label": "Cadillac Escalade", "value": "Escalade", "query": "model" },
  { "label": "Cadillac Escalade ESV", "value": "Escalade ESV", "query": "model" },
  { "label": "Cadillac Escalade EXT", "value": "Escalade EXT", "query": "model" },
  { "label": "Cadillac LYRIQ", "value": "LYRIQ", "query": "model" },
  { "label": "Cadillac SRX", "value": "SRX", "query": "model" },
  { "label": "Cadillac STS", "value": "STS", "query": "model" },
  { "label": "Cadillac XT4", "value": "XT4", "query": "model" },
  { "label": "Cadillac XT5", "value": "XT5", "query": "model" },
  { "label": "Cadillac XT6", "value": "XT6", "query": "model" },
  { "label": "Cadillac XTS", "value": "XTS", "query": "model" },

  { "label": "Chevrolet Captiva", "value": "Captiva", "query": "model" },
  { "label": "Chevrolet Avalanche", "value": "Avalanche", "query": "model" },
  { "label": "Chevrolet Aveo", "value": "Aveo", "query": "model" },
  { "label": "Chevrolet Aveo5", "value": "Aveo5", "query": "model" },
  { "label": "Chevrolet Beat", "value": "Beat", "query": "model" },
  { "label": "Chevrolet Blazer", "value": "Blazer", "query": "model" },
  { "label": "Chevrolet Bolt EUV", "value": "Bolt EUV", "query": "model" },
  { "label": "Chevrolet Bolt EV", "value": "Bolt EV", "query": "model" },
  { "label": "Chevrolet Camaro", "value": "Camaro", "query": "model" },
  { "label": "Chevrolet Caprice", "value": "Caprice", "query": "model" },
  { "label": "Chevrolet Captiva Sport", "value": "Captiva Sport", "query": "model" },
  { "label": "Chevrolet Cavalier", "value": "Cavalier", "query": "model" },
  { "label": "Chevrolet Chevy", "value": "Chevy", "query": "model" },
  { "label": "Chevrolet Cheyenne", "value": "Cheyenne", "query": "model" },
  { "label": "Chevrolet City Express", "value": "City Express", "query": "model" },
  { "label": "Chevrolet Cobalt", "value": "Cobalt", "query": "model" },
  { "label": "Chevrolet Colorado", "value": "Colorado", "query": "model" },
  { "label": "Chevrolet Corvette", "value": "Corvette", "query": "model" },
  { "label": "Chevrolet Cruze", "value": "Cruze", "query": "model" },
  { "label": "Chevrolet Cruze Limited", "value": "Cruze Limited", "query": "model" },
  { "label": "Chevrolet Cruze NG", "value": "Cruze NG", "query": "model" },
  { "label": "Chevrolet Equinox", "value": "Equinox", "query": "model" },
  { "label": "Chevrolet Express 1500", "value": "Express 1500", "query": "model" },
  { "label": "Chevrolet Express 2500", "value": "Express 2500", "query": "model" },
  { "label": "Chevrolet Express 3500", "value": "Express 3500", "query": "model" },
  { "label": "Chevrolet Express 4500", "value": "Express 4500", "query": "model" },
  { "label": "Chevrolet Express Cargo", "value": "Express Cargo", "query": "model" },
  { "label": "Chevrolet Express Pasajeros", "value": "Express Pasajeros", "query": "model" },
  { "label": "Chevrolet Groove", "value": "Groove", "query": "model" },
  { "label": "Chevrolet HHR", "value": "HHR", "query": "model" },
  { "label": "Chevrolet Impala", "value": "Impala", "query": "model" },
  { "label": "Chevrolet Impala Limited", "value": "Impala Limited", "query": "model" },
  { "label": "Chevrolet LCF 3500", "value": "LCF 3500", "query": "model" },
  { "label": "Chevrolet LCF 3500HD", "value": "LCF 3500HD", "query": "model" },
  { "label": "Chevrolet LCF 4500", "value": "LCF 4500", "query": "model" },
  { "label": "Chevrolet LCF 4500HD", "value": "LCF 4500HD", "query": "model" },
  { "label": "Chevrolet LCF 4500XD", "value": "LCF 4500XD", "query": "model" },
  { "label": "Chevrolet LCF 5500HD", "value": "LCF 5500HD", "query": "model" },
  { "label": "Chevrolet LCF 5500XD", "value": "LCF 5500XD", "query": "model" },
  { "label": "Chevrolet LCF 6500XD", "value": "LCF 6500XD", "query": "model" },
  { "label": "Chevrolet Malibu", "value": "Malibu", "query": "model" },
  { "label": "Chevrolet Malibu Limited", "value": "Malibu Limited", "query": "model" },
  { "label": "Chevrolet Matiz", "value": "Matiz", "query": "model" },
  { "label": "Chevrolet Nuevo Aveo", "value": "Nuevo Aveo", "query": "model" },
  { "label": "Chevrolet Onix", "value": "Onix", "query": "model" },
  { "label": "Chevrolet Optra", "value": "Optra", "query": "model" },
  { "label": "Chevrolet Orlando", "value": "Orlando", "query": "model" },
  { "label": "Chevrolet S10", "value": "S10", "query": "model" },
  { "label": "Chevrolet Silverado", "value": "Silverado", "query": "model" },
  { "label": "Chevrolet Sonic", "value": "Sonic", "query": "model" },
  { "label": "Chevrolet Spark", "value": "Spark", "query": "model" },
  { "label": "Chevrolet Spark Classic", "value": "Spark Classic", "query": "model" },
  { "label": "Chevrolet Spark EV", "value": "Spark EV", "query": "model" },
  { "label": "Chevrolet SS", "value": "SS", "query": "model" },
  { "label": "Chevrolet Suburban", "value": "Suburban", "query": "model" },
  { "label": "Chevrolet Suburban 1500", "value": "Suburban 1500", "query": "model" },
  { "label": "Chevrolet Suburban 2500", "value": "Suburban 2500", "query": "model" },
  { "label": "Chevrolet Suburban 3500 HD", "value": "Suburban 3500 HD", "query": "model" },
  { "label": "Chevrolet Tahoe", "value": "Tahoe", "query": "model" },
  { "label": "Chevrolet Tornado", "value": "Tornado", "query": "model" },
  { "label": "Chevrolet Tornado Van", "value": "Tornado Van", "query": "model" },
  { "label": "Chevrolet Tracker", "value": "Tracker", "query": "model" },
  { "label": "Chevrolet Trailblazer", "value": "Trailblazer", "query": "model" },
  { "label": "Chevrolet Traverse", "value": "Traverse", "query": "model" },
  { "label": "Chevrolet Trax", "value": "Trax", "query": "model" },
  { "label": "Chevrolet Volt", "value": "Volt", "query": "model" },
  { "label": "Chevrolet W4500 Tiltmaster", "value": "W4500 Tiltmaster", "query": "model" },
  { "label": "Chevrolet W5500 Tiltmaster", "value": "W5500 Tiltmaster", "query": "model" },

  { "label": "Chrysler 200", "value": "200", "query": "model" },
  { "label": "Chrysler 300", "value": "300", "query": "model" },
  { "label": "Chrysler Cirrus", "value": "Cirrus", "query": "model" },
  { "label": "Chrysler Grand Caravan", "value": "Grand Caravan", "query": "model" },
  { "label": "Chrysler Pacifica", "value": "Pacifica", "query": "model" },
  { "label": "Chrysler PT Cruiser", "value": "PT Cruiser", "query": "model" },
  { "label": "Chrysler Sebring", "value": "Sebring", "query": "model" },
  { "label": "Chrysler Town & Country", "value": "Town & Country", "query": "model" },
  { "label": "Chrysler Voyager", "value": "Voyager", "query": "model" },
  
  { "label": "Dodge Atos", "value": "Atos", "query": "model" },
  { "label": "Dodge Attitude", "value": "Attitude", "query": "model" },
  { "label": "Dodge Avenger", "value": "Avenger", "query": "model" },
  { "label": "Dodge Caliber", "value": "Caliber", "query": "model" },
  { "label": "Dodge Challenger", "value": "Challenger", "query": "model" },
  { "label": "Dodge Charger", "value": "Charger", "query": "model" },
  { "label": "Dodge Dakota", "value": "Dakota", "query": "model" },
  { "label": "Dodge Dart", "value": "Dart", "query": "model" },
  { "label": "Dodge Durango", "value": "Durango", "query": "model" },
  { "label": "Dodge H100", "value": "H100", "query": "model" },
  { "label": "Dodge H100 Van", "value": "H100 Van", "query": "model" },
  { "label": "Dodge Hornet", "value": "Hornet", "query": "model" },
  { "label": "Dodge i10", "value": "i10", "query": "model" },
  { "label": "Dodge Journey", "value": "Journey", "query": "model" },
  { "label": "Dodge Neon", "value": "Neon", "query": "model" },
  { "label": "Dodge Nitro", "value": "Nitro", "query": "model" },
  { "label": "Dodge Ram 1500", "value": "Ram 1500", "query": "model" },
  { "label": "Dodge Ram 2500", "value": "Ram 2500", "query": "model" },
  { "label": "Dodge Ram 3500", "value": "Ram 3500", "query": "model" },
  { "label": "Dodge Ram 4000", "value": "Ram 4000", "query": "model" },
  { "label": "Dodge Ram 4500", "value": "Ram 4500", "query": "model" },
  { "label": "Dodge Ram 5500", "value": "Ram 5500", "query": "model" },
  { "label": "Dodge Viper", "value": "Viper", "query": "model" },
  { "label": "Dodge Vision", "value": "Vision", "query": "model" },
  
  { "label": "Ferrari 296 GTB", "value": "296 GTB", "query": "model" },
  { "label": "Ferrari 458 Italia", "value": "458 Italia", "query": "model" },
  { "label": "Ferrari 458 Speciale", "value": "458 Speciale", "query": "model" },
  { "label": "Ferrari 458 Spider", "value": "458 Spider", "query": "model" },
  { "label": "Ferrari 488 GTB", "value": "488 GTB", "query": "model" },
  { "label": "Ferrari 488 Pista", "value": "488 Pista", "query": "model" },
  { "label": "Ferrari 488 Pista Spider", "value": "488 Pista Spider", "query": "model" },
  { "label": "Ferrari 488 Spider", "value": "488 Spider", "query": "model" },
  { "label": "Ferrari 599 GTB", "value": "599 GTB", "query": "model" },
  { "label": "Ferrari 599 GTO", "value": "599 GTO", "query": "model" },
  { "label": "Ferrari 612 Scaglietti", "value": "612 Scaglietti", "query": "model" },
  { "label": "Ferrari 812 GTS", "value": "812 GTS", "query": "model" },
  { "label": "Ferrari 812 Superfast", "value": "812 Superfast", "query": "model" },
  { "label": "Ferrari California", "value": "California", "query": "model" },
  { "label": "Ferrari California T", "value": "California T", "query": "model" },
  { "label": "Ferrari F12 Berlinetta", "value": "F12 Berlinetta", "query": "model" },
  { "label": "Ferrari F12tdf", "value": "F12tdf", "query": "model" },
  { "label": "Ferrari F8 Spider", "value": "F8 Spider", "query": "model" },
  { "label": "Ferrari F8 Tributo", "value": "F8 Tributo", "query": "model" },
  { "label": "Ferrari FF", "value": "FF", "query": "model" },
  { "label": "Ferrari GTC4Lusso", "value": "GTC4Lusso", "query": "model" },
  { "label": "Ferrari GTC4Lusso T", "value": "GTC4Lusso T", "query": "model" },
  { "label": "Ferrari LaFerrari", "value": "LaFerrari", "query": "model" },
  { "label": "Ferrari Portofino", "value": "Portofino", "query": "model" },
  { "label": "Ferrari Portofino M", "value": "Portofino M", "query": "model" },
  { "label": "Ferrari Roma", "value": "Roma", "query": "model" },
  { "label": "Ferrari SF90 Spider", "value": "SF90 Spider", "query": "model" },
  { "label": "Ferrari SF90 Stradale", "value": "SF90 Stradale", "query": "model" },

  { "label": "Fiat 500", "value": "500", "query": "model" },
  { "label": "Fiat 124 Spider", "value": "124 Spider", "query": "model" },
  { "label": "Fiat 500L", "value": "500L", "query": "model" },
  { "label": "Fiat 500X", "value": "500X", "query": "model" },
  { "label": "Fiat Albea", "value": "Albea", "query": "model" },
  { "label": "Fiat Argo", "value": "Argo", "query": "model" },
  { "label": "Fiat Ducato", "value": "Ducato", "query": "model" },
  { "label": "Fiat Linea", "value": "Linea", "query": "model" },
  { "label": "Fiat Mobi", "value": "Mobi", "query": "model" },
  { "label": "Fiat Palio", "value": "Palio", "query": "model" },
  { "label": "Fiat Panda", "value": "Panda", "query": "model" },
  { "label": "Fiat Punto", "value": "Punto", "query": "model" },
  { "label": "Fiat Strada", "value": "Strada", "query": "model" },
  { "label": "Fiat Uno", "value": "Uno", "query": "model" },
  { "label": "Fiat JOLLY", "value": "JOLLY", "query": "model" },
  { "label": "Fiat 500C", "value": "500C", "query": "model" },
  { "label": "Fiat 500E", "value": "500E", "query": "model" },

  { "label": "Fisker Karma", "value": "Karma", "query": "model" },
  { "label": "Fisker OCEAN", "value": "OCEAN", "query": "model" },

  { "label": "Ford Bronco", "value": "Bronco", "query": "model" },
  { "label": "Ford Bronco Sport", "value": "Bronco Sport", "query": "model" },
  { "label": "Ford C-Max", "value": "C-Max", "query": "model" },
  { "label": "Ford Courier", "value": "Courier", "query": "model" },
  { "label": "Ford Crown Victoria", "value": "Crown Victoria", "query": "model" },
  { "label": "Ford E-150", "value": "E-150", "query": "model" },
  { "label": "Ford E-250", "value": "E-250", "query": "model" },
  { "label": "Ford E-350 Super Duty", "value": "E-350 Super Duty", "query": "model" },
  { "label": "Ford E-450 Super Duty", "value": "E-450 Super Duty", "query": "model" },
  { "label": "Ford E-Transit", "value": "E-Transit", "query": "model" },
  { "label": "Ford Econoline Van", "value": "Econoline Van", "query": "model" },
  { "label": "Ford Econoline Wagon", "value": "Econoline Wagon", "query": "model" },
  { "label": "Ford EcoSport", "value": "EcoSport", "query": "model" },
  { "label": "Ford Edge", "value": "Edge", "query": "model" },
  { "label": "Ford Escape", "value": "Escape", "query": "model" },
  { "label": "Ford Expedition", "value": "Expedition", "query": "model" },
  { "label": "Ford Explorer", "value": "Explorer", "query": "model" },
  { "label": "Ford Explorer Sport Trac", "value": "Explorer Sport Trac", "query": "model" },
  { "label": "Ford F-150", "value": "F-150", "query": "model" },
  { "label": "Ford F-150 Lightning", "value": "F-150 Lightning", "query": "model" },
  { "label": "Ford F-250", "value": "F-250", "query": "model" },
  { "label": "Ford F-250 Super Duty", "value": "F-250 Super Duty", "query": "model" },
  { "label": "Ford F-350", "value": "F-350", "query": "model" },
  { "label": "Ford F-350 Super Duty", "value": "F-350 Super Duty", "query": "model" },
  { "label": "Ford F-450", "value": "F-450", "query": "model" },
  { "label": "Ford F-450 Super Duty", "value": "F-450 Super Duty", "query": "model" },
  { "label": "Ford F-550 Super Duty", "value": "F-550 Super Duty", "query": "model" },
  { "label": "Ford F-600 Super Duty", "value": "F-600 Super Duty", "query": "model" },
  { "label": "Ford F53", "value": "F53", "query": "model" },
  { "label": "Ford F59", "value": "F59", "query": "model" },
  { "label": "Ford F650", "value": "F650", "query": "model" },
  { "label": "Ford F750", "value": "F750", "query": "model" },
  { "label": "Ford Fiesta", "value": "Fiesta", "query": "model" },
  { "label": "Ford Fiesta Ikon", "value": "Fiesta Ikon", "query": "model" },
  { "label": "Ford Figo", "value": "Figo", "query": "model" },
  { "label": "Ford Flex", "value": "Flex", "query": "model" },
  { "label": "Ford Focus", "value": "Focus", "query": "model" },
  { "label": "Ford Fusion", "value": "Fusion", "query": "model" },
  { "label": "Ford GT", "value": "GT", "query": "model" },
  { "label": "Ford LCF", "value": "LCF", "query": "model" },
  { "label": "Ford Lobo", "value": "Lobo", "query": "model" },
  { "label": "Ford Maverick", "value": "Maverick", "query": "model" },
  { "label": "Ford Mustang", "value": "Mustang", "query": "model" },
  { "label": "Ford Mustang Mach-E", "value": "Mustang Mach-E", "query": "model" },
  { "label": "Ford Police Interceptor Sedan", "value": "Police Interceptor Sedan", "query": "model" },
  { "label": "Ford Police Interceptor Utility", "value": "Police Interceptor Utility", "query": "model" },
  { "label": "Ford Police Responder Hybrid", "value": "Police Responder Hybrid", "query": "model" },
  { "label": "Ford Ranger", "value": "Ranger", "query": "model" },
  { "label": "Ford Special Service Police Sedan", "value": "Special Service Police Sedan", "query": "model" },
  { "label": "Ford SSV Plug-In Hybrid", "value": "SSV Plug-In Hybrid", "query": "model" },
  { "label": "Ford Taurus", "value": "Taurus", "query": "model" },
  { "label": "Ford Transit", "value": "Transit", "query": "model" },
  { "label": "Ford Transit Connect", "value": "Transit Connect", "query": "model" },
  { "label": "Ford Transit Courier", "value": "Transit Courier", "query": "model" },
  { "label": "Ford Transit Custom", "value": "Transit Custom", "query": "model" },
  { "label": "Ford Transit-150", "value": "Transit-150", "query": "model" },
  { "label": "Ford Transit-250", "value": "Transit-250", "query": "model" },
  { "label": "Ford Transit-350", "value": "Transit-350", "query": "model" },
  { "label": "Ford Transit-350 HD", "value": "Transit-350 HD", "query": "model" },
  { "label": "Ford SHELBY", "value": "SHELBY", "query": "model" },

  { "label": "GMC Acadia", "value": "Acadia", "query": "model" },
  { "label": "GMC Acadia Limited", "value": "Acadia Limited", "query": "model" },
  { "label": "GMC Canyon", "value": "Canyon", "query": "model" },
  { "label": "GMC Hummer EV", "value": "Hummer EV", "query": "model" },
  { "label": "GMC Savana", "value": "Savana", "query": "model" },
  { "label": "GMC Savana 1500", "value": "Savana 1500", "query": "model" },
  { "label": "GMC Savana 2500", "value": "Savana 2500", "query": "model" },
  { "label": "GMC Savana 3500", "value": "Savana 3500", "query": "model" },
  { "label": "GMC Savana 4500", "value": "Savana 4500", "query": "model" },
  { "label": "GMC Sierra", "value": "Sierra", "query": "model" },
  { "label": "GMC Sierra 1500", "value": "Sierra 1500", "query": "model" },
  { "label": "GMC Sierra 1500 Limited", "value": "Sierra 1500 Limited", "query": "model" },
  { "label": "GMC Sierra 2500 HD", "value": "Sierra 2500 HD", "query": "model" },
  { "label": "GMC Sierra 3500 HD", "value": "Sierra 3500 HD", "query": "model" },
  { "label": "GMC Terrain", "value": "Terrain", "query": "model" },
  { "label": "GMC W4500 Forward", "value": "W4500 Forward", "query": "model" },
  { "label": "GMC W5500 Forward", "value": "W5500 Forward", "query": "model" },
  { "label": "GMC Yukon", "value": "Yukon", "query": "model" },
  { "label": "GMC Yukon XL", "value": "Yukon XL", "query": "model" },
  { "label": "GMC Yukon XL 1500", "value": "Yukon XL 1500", "query": "model" },
  { "label": "GMC Yukon XL 2500", "value": "Yukon XL 2500", "query": "model" },

  { "label": "Genesis G70", "value": "G70", "query": "model" },
  { "label": "Genesis G80", "value": "G80", "query": "model" },
  { "label": "Genesis G90", "value": "G90", "query": "model" },
  { "label": "Genesis GV70", "value": "GV70", "query": "model" },
  { "label": "Genesis GV80", "value": "GV80", "query": "model" },
  { "label": "Genesis GV60", "value": "GV60", "query": "model" },

  { "label": "Honda Accord", "value": "Accord", "query": "model" },
  { "label": "Honda Accord Crosstour", "value": "Accord Crosstour", "query": "model" },
  { "label": "Honda BR-V", "value": "BR-V", "query": "model" },
  { "label": "Honda City", "value": "City", "query": "model" },
  { "label": "Honda Civic", "value": "Civic", "query": "model" },
  { "label": "Honda Clarity", "value": "Clarity", "query": "model" },
  { "label": "Honda Clarity Plug-In Hybrid", "value": "Clarity Plug-In Hybrid", "query": "model" },
  { "label": "Honda CR-V", "value": "CR-V", "query": "model" },
  { "label": "Honda CR-Z", "value": "CR-Z", "query": "model" },
  { "label": "Honda Crosstour", "value": "Crosstour", "query": "model" },
  { "label": "Honda Element", "value": "Element", "query": "model" },
  { "label": "Honda Fit", "value": "Fit", "query": "model" },
  { "label": "Honda HR-V", "value": "HR-V", "query": "model" },
  { "label": "Honda Insight", "value": "Insight", "query": "model" },
  { "label": "Honda Odyssey", "value": "Odyssey", "query": "model" },
  { "label": "Honda Passport", "value": "Passport", "query": "model" },
  { "label": "Honda Pilot", "value": "Pilot", "query": "model" },
  { "label": "Honda Ridgeline", "value": "Ridgeline", "query": "model" },

  { "label": "Hummer H3", "value": "H3", "query": "model" },
  { "label": "Hummer H3T", "value": "H3T", "query": "model" },

  { "label": "Hyundai Accent", "value": "Accent", "query": "model" },
  { "label": "Hyundai Azera", "value": "Azera", "query": "model" },
  { "label": "Hyundai Creta", "value": "Creta", "query": "model" },
  { "label": "Hyundai Creta Grand", "value": "Creta Grand", "query": "model" },
  { "label": "Hyundai Elantra", "value": "Elantra", "query": "model" },
  { "label": "Hyundai Elantra Coupe", "value": "Elantra Coupe", "query": "model" },
  { "label": "Hyundai Elantra GT", "value": "Elantra GT", "query": "model" },
  { "label": "Hyundai Elantra N", "value": "Elantra N", "query": "model" },
  { "label": "Hyundai Entourage", "value": "Entourage", "query": "model" },
  { "label": "Hyundai Equus", "value": "Equus", "query": "model" },
  { "label": "Hyundai EX6", "value": "EX6", "query": "model" },
  { "label": "Hyundai EX8", "value": "EX8", "query": "model" },
  { "label": "Hyundai Genesis", "value": "Genesis", "query": "model" },
  { "label": "Hyundai Genesis Coupe", "value": "Genesis Coupe", "query": "model" },
  { "label": "Hyundai Grand i10", "value": "Grand i10", "query": "model" },
  { "label": "Hyundai H200", "value": "H200", "query": "model" },
  { "label": "Hyundai H300", "value": "H300", "query": "model" },
  { "label": "Hyundai H400", "value": "H400", "query": "model" },
  { "label": "Hyundai H500", "value": "H500", "query": "model" },
  { "label": "Hyundai HD55", "value": "HD55", "query": "model" },
  { "label": "Hyundai HD65", "value": "HD65", "query": "model" },
  { "label": "Hyundai HD78", "value": "HD78", "query": "model" },
  { "label": "Hyundai Ioniq", "value": "Ioniq", "query": "model" },
  { "label": "Hyundai Ioniq 5", "value": "Ioniq 5", "query": "model" },
  { "label": "Hyundai ix35", "value": "ix35", "query": "model" },
  { "label": "Hyundai Kona", "value": "Kona", "query": "model" },
  { "label": "Hyundai Kona Electric", "value": "Kona Electric", "query": "model" },
  { "label": "Hyundai Kona N", "value": "Kona N", "query": "model" },
  { "label": "Hyundai Nexo", "value": "Nexo", "query": "model" },
  { "label": "Hyundai Palisade", "value": "Palisade", "query": "model" },
  { "label": "Hyundai Santa Cruz", "value": "Santa Cruz", "query": "model" },
  { "label": "Hyundai Santa Fe", "value": "Santa Fe", "query": "model" },
  { "label": "Hyundai Santa Fe XL", "value": "Santa Fe XL", "query": "model" },
  { "label": "Hyundai Sonata", "value": "Sonata", "query": "model" },
  { "label": "Hyundai Starex", "value": "Starex", "query": "model" },
  { "label": "Hyundai Tucson", "value": "Tucson", "query": "model" },
  { "label": "Hyundai Veloster", "value": "Veloster", "query": "model" },
  { "label": "Hyundai Veloster N", "value": "Veloster N", "query": "model" },
  { "label": "Hyundai Venue", "value": "Venue", "query": "model" },
  { "label": "Hyundai Veracruz", "value": "Veracruz", "query": "model" },

  { "label": "Infiniti EX35", "value": "EX35", "query": "model" },
  { "label": "Infiniti EX37", "value": "EX37", "query": "model" },
  { "label": "Infiniti FX35", "value": "FX35", "query": "model" },
  { "label": "Infiniti FX37", "value": "FX37", "query": "model" },
  { "label": "Infiniti FX50", "value": "FX50", "query": "model" },
  { "label": "Infiniti G25", "value": "G25", "query": "model" },
  { "label": "Infiniti G37", "value": "G37", "query": "model" },
  { "label": "Infiniti JX35", "value": "JX35", "query": "model" },
  { "label": "Infiniti M35", "value": "M35", "query": "model" },
  { "label": "Infiniti M35h", "value": "M35h", "query": "model" },
  { "label": "Infiniti M37", "value": "M37", "query": "model" },
  { "label": "Infiniti M45", "value": "M45", "query": "model" },
  { "label": "Infiniti M56", "value": "M56", "query": "model" },
  { "label": "Infiniti Q40", "value": "Q40", "query": "model" },
  { "label": "Infiniti Q50", "value": "Q50", "query": "model" },
  { "label": "Infiniti Q60", "value": "Q60", "query": "model" },
  { "label": "Infiniti Q70", "value": "Q70", "query": "model" },
  { "label": "Infiniti Q70L", "value": "Q70L", "query": "model" },
  { "label": "Infiniti QX30", "value": "QX30", "query": "model" },
  { "label": "Infiniti QX50", "value": "QX50", "query": "model" },
  { "label": "Infiniti QX55", "value": "QX55", "query": "model" },
  { "label": "Infiniti QX56", "value": "QX56", "query": "model" },
  { "label": "Infiniti QX60", "value": "QX60", "query": "model" },
  { "label": "Infiniti QX70", "value": "QX70", "query": "model" },
  { "label": "Infiniti QX80", "value": "QX80", "query": "model" },
  { "label": "Infiniti G35", "value": "G35", "query": "model" },

  { "label": "Isuzu ELF 100", "value": "ELF 100", "query": "model" },
  { "label": "Isuzu ELF 200", "value": "ELF 200", "query": "model" },
  { "label": "Isuzu ELF 300", "value": "ELF 300", "query": "model" },
  { "label": "Isuzu ELF 400", "value": "ELF 400", "query": "model" },
  { "label": "Isuzu ELF 500", "value": "ELF 500", "query": "model" },
  { "label": "Isuzu ELF 600", "value": "ELF 600", "query": "model" },
  { "label": "Isuzu ELF 600-BUS", "value": "ELF 600-BUS", "query": "model" },
  { "label": "Isuzu Forward 1100", "value": "Forward 1100", "query": "model" },
  { "label": "Isuzu Forward 1400", "value": "Forward 1400", "query": "model" },
  { "label": "Isuzu Forward 800", "value": "Forward 800", "query": "model" },
  { "label": "Isuzu FTR", "value": "FTR", "query": "model" },
  { "label": "Isuzu FVR", "value": "FVR", "query": "model" },
  { "label": "Isuzu FXR", "value": "FXR", "query": "model" },
  { "label": "Isuzu NPR", "value": "NPR", "query": "model" },
  { "label": "Isuzu NPR-HD", "value": "NPR-HD", "query": "model" },
  { "label": "Isuzu NPR-XD", "value": "NPR-XD", "query": "model" },
  { "label": "Isuzu NQR", "value": "NQR", "query": "model" },
  { "label": "Isuzu NRR", "value": "NRR", "query": "model" },
  { "label": "Isuzu Reach", "value": "Reach", "query": "model" },

  { "label": "Jaguar E-Pace", "value": "E-Pace", "query": "model" },
  { "label": "Jaguar F-Pace", "value": "F-Pace", "query": "model" },
  { "label": "Jaguar F-Type", "value": "F-Type", "query": "model" },
  { "label": "Jaguar I-Pace", "value": "I-Pace", "query": "model" },
  { "label": "Jaguar XE", "value": "XE", "query": "model" },
  { "label": "Jaguar XF", "value": "XF", "query": "model" },
  { "label": "Jaguar XFR", "value": "XFR", "query": "model" },
  { "label": "Jaguar XFR-S", "value": "XFR-S", "query": "model" },
  { "label": "Jaguar XJ", "value": "XJ", "query": "model" },
  { "label": "Jaguar XJR", "value": "XJR", "query": "model" },
  { "label": "Jaguar XJR575", "value": "XJR575", "query": "model" },
  { "label": "Jaguar XK", "value": "XK", "query": "model" },
  { "label": "Jaguar XKR", "value": "XKR", "query": "model" },
  { "label": "Jaguar XKR-S", "value": "XKR-S", "query": "model" },

  { "label": "Jeep Cherokee", "value": "Cherokee", "query": "model" },
  { "label": "Jeep Commander", "value": "Commander", "query": "model" },
  { "label": "Jeep Compass", "value": "Compass", "query": "model" },
  { "label": "Jeep Gladiator", "value": "Gladiator", "query": "model" },
  { "label": "Jeep Grand Cherokee", "value": "Grand Cherokee", "query": "model" },
  { "label": "Jeep Grand Cherokee L", "value": "Grand Cherokee L", "query": "model" },
  { "label": "Jeep Grand Cherokee WK", "value": "Grand Cherokee WK", "query": "model" },
  { "label": "Jeep Grand Wagoneer", "value": "Grand Wagoneer", "query": "model" },
  { "label": "Jeep Liberty", "value": "Liberty", "query": "model" },
  { "label": "Jeep Patriot", "value": "Patriot", "query": "model" },
  { "label": "Jeep Renegade", "value": "Renegade", "query": "model" },
  { "label": "Jeep Wagoneer", "value": "Wagoneer", "query": "model" },
  { "label": "Jeep Wrangler", "value": "Wrangler", "query": "model" },
  { "label": "Jeep Wrangler JK", "value": "Wrangler JK", "query": "model" },

  { "label": "Kia Borrego", "value": "Borrego", "query": "model" },
  { "label": "Kia Cadenza", "value": "Cadenza", "query": "model" },
  { "label": "Kia Carnival", "value": "Carnival", "query": "model" },
  { "label": "Kia EV6", "value": "EV6", "query": "model" },
  { "label": "Kia Forte", "value": "Forte", "query": "model" },
  { "label": "Kia Forte Koup", "value": "Forte Koup", "query": "model" },
  { "label": "Kia Forte5", "value": "Forte5", "query": "model" },
  { "label": "Kia K5", "value": "K5", "query": "model" },
  { "label": "Kia K900", "value": "K900", "query": "model" },
  { "label": "Kia Magentis", "value": "Magentis", "query": "model" },
  { "label": "Kia Niro", "value": "Niro", "query": "model" },
  { "label": "Kia Niro EV", "value": "Niro EV", "query": "model" },
  { "label": "Kia Optima", "value": "Optima", "query": "model" },
  { "label": "Kia Rio", "value": "Rio", "query": "model" },
  { "label": "Kia Rio5", "value": "Rio5", "query": "model" },
  { "label": "Kia Rondo", "value": "Rondo", "query": "model" },
  { "label": "Kia Sedona", "value": "Sedona", "query": "model" },
  { "label": "Kia Seltos", "value": "Seltos", "query": "model" },
  { "label": "Kia Sorento", "value": "Sorento", "query": "model" },
  { "label": "Kia Soul", "value": "Soul", "query": "model" },
  { "label": "Kia Soul EV", "value": "Soul EV", "query": "model" },
  { "label": "Kia Sportage", "value": "Sportage", "query": "model" },
  { "label": "Kia Stinger", "value": "Stinger", "query": "model" },
  { "label": "Kia Telluride", "value": "Telluride", "query": "model" },

  { "label": "Lamborghini Aventador", "value": "Aventador", "query": "model" },
  { "label": "Lamborghini Centenario", "value": "Centenario", "query": "model" },
  { "label": "Lamborghini Gallardo", "value": "Gallardo", "query": "model" },
  { "label": "Lamborghini Huracan", "value": "Huracan", "query": "model" },
  { "label": "Lamborghini Murcielago", "value": "Murcielago", "query": "model" },
  { "label": "Lamborghini Urus", "value": "Urus", "query": "model" },
  { "label": "Lamborghini Veneno", "value": "Veneno", "query": "model" },

  { "label": "Land Rover Defender", "value": "Defender", "query": "model" },
  { "label": "Land Rover Defender 110", "value": "Defender 110", "query": "model" },
  { "label": "Land Rover Defender 130", "value": "Defender 130", "query": "model" },
  { "label": "Land Rover Defender 90", "value": "Defender 90", "query": "model" },
  { "label": "Land Rover Discovery", "value": "Discovery", "query": "model" },
  { "label": "Land Rover Discovery Sport", "value": "Discovery Sport", "query": "model" },
  { "label": "Land Rover LR2", "value": "LR2", "query": "model" },
  { "label": "Land Rover LR4", "value": "LR4", "query": "model" },
  { "label": "Land Rover Range Rover", "value": "Range Rover", "query": "model" },
  { "label": "Land Rover Range Rover Evoque", "value": "Range Rover Evoque", "query": "model" },
  { "label": "Land Rover Range Rover Sport", "value": "Range Rover Sport", "query": "model" },
  { "label": "Land Rover Range Rover Velar", "value": "Range Rover Velar", "query": "model" },

  { "label": "Lexus CT200h", "value": "CT200h", "query": "model" },
  { "label": "Lexus ES250", "value": "ES250", "query": "model" },
  { "label": "Lexus ES300h", "value": "ES300h", "query": "model" },
  { "label": "Lexus ES350", "value": "ES350", "query": "model" },
  { "label": "Lexus GS F", "value": "GS F", "query": "model" },
  { "label": "Lexus GS200t", "value": "GS200t", "query": "model" },
  { "label": "Lexus GS300", "value": "GS300", "query": "model" },
  { "label": "Lexus GS350", "value": "GS350", "query": "model" },
  { "label": "Lexus GS450h", "value": "GS450h", "query": "model" },
  { "label": "Lexus GS460", "value": "GS460", "query": "model" },
  { "label": "Lexus GX460", "value": "GX460", "query": "model" },
  { "label": "Lexus HS250h", "value": "HS250h", "query": "model" },
  { "label": "Lexus IS F", "value": "IS F", "query": "model" },
  { "label": "Lexus IS200t", "value": "IS200t", "query": "model" },
  { "label": "Lexus IS250", "value": "IS250", "query": "model" },
  { "label": "Lexus IS300", "value": "IS300", "query": "model" },
  { "label": "Lexus IS350", "value": "IS350", "query": "model" },
  { "label": "Lexus IS500", "value": "IS500", "query": "model" },
  { "label": "Lexus LC500", "value": "LC500", "query": "model" },
  { "label": "Lexus LC500h", "value": "LC500h", "query": "model" },
  { "label": "Lexus LFA", "value": "LFA", "query": "model" },
  { "label": "Lexus LS460", "value": "LS460", "query": "model" },
  { "label": "Lexus LS500", "value": "LS500", "query": "model" },
  { "label": "Lexus LS500h", "value": "LS500h", "query": "model" },
  { "label": "Lexus LS600h", "value": "LS600h", "query": "model" },
  { "label": "Lexus LX570", "value": "LX570", "query": "model" },
  { "label": "Lexus LX600", "value": "LX600", "query": "model" },
  { "label": "Lexus NX200t", "value": "NX200t", "query": "model" },
  { "label": "Lexus NX250", "value": "NX250", "query": "model" },
  { "label": "Lexus NX300", "value": "NX300", "query": "model" },
  { "label": "Lexus NX300h", "value": "NX300h", "query": "model" },
  { "label": "Lexus NX350", "value": "NX350", "query": "model" },
  { "label": "Lexus NX350h", "value": "NX350h", "query": "model" },
  { "label": "Lexus NX450h+", "value": "NX450h+", "query": "model" },
  { "label": "Lexus RC F", "value": "RC F", "query": "model" },
  { "label": "Lexus RC200t", "value": "RC200t", "query": "model" },
  { "label": "Lexus RC300", "value": "RC300", "query": "model" },
  { "label": "Lexus RC350", "value": "RC350", "query": "model" },
  { "label": "Lexus RX350", "value": "RX350", "query": "model" },
  { "label": "Lexus RX350L", "value": "RX350L", "query": "model" },
  { "label": "Lexus RX450h", "value": "RX450h", "query": "model" },
  { "label": "Lexus RX450hL", "value": "RX450hL", "query": "model" },
  { "label": "Lexus SC430", "value": "SC430", "query": "model" },
  { "label": "Lexus UX200", "value": "UX200", "query": "model" },
  { "label": "Lexus UX250h", "value": "UX250h", "query": "model" },

  { "label": "Lincoln Aviator", "value": "Aviator", "query": "model" },
  { "label": "Lincoln Corsair", "value": "Corsair", "query": "model" },
  { "label": "Lincoln Mark LT", "value": "Mark LT", "query": "model" },
  { "label": "Lincoln MKC", "value": "MKC", "query": "model" },
  { "label": "Lincoln MKS", "value": "MKS", "query": "model" },
  { "label": "Lincoln MKT", "value": "MKT", "query": "model" },
  { "label": "Lincoln MKX", "value": "MKX", "query": "model" },
  { "label": "Lincoln MKZ", "value": "MKZ", "query": "model" },
  { "label": "Lincoln Nautilus", "value": "Nautilus", "query": "model" },
  { "label": "Lincoln Navigator", "value": "Navigator", "query": "model" },
  { "label": "Lincoln Town Car", "value": "Town Car", "query": "model" },

  { "label": "Lotus Elise", "value": "Elise", "query": "model" },
  { "label": "Lotus Emira", "value": "Emira", "query": "model" },
  { "label": "Lotus Evora", "value": "Evora", "query": "model" },
  { "label": "Lotus Evora GT", "value": "Evora GT", "query": "model" },
  { "label": "Lotus Exige", "value": "Exige", "query": "model" },

  { "label": "Lucid Air", "value": "Air", "query": "model" },

  { "label": "Maserati Ghibli", "value": "Ghibli", "query": "model" },
  { "label": "Maserati GranCabrio", "value": "GranCabrio", "query": "model" },
  { "label": "Maserati GranTurismo", "value": "GranTurismo", "query": "model" },
  { "label": "Maserati Grecale", "value": "Grecale", "query": "model" },
  { "label": "Maserati Levante", "value": "Levante", "query": "model" },
  { "label": "Maserati MC20", "value": "MC20", "query": "model" },
  { "label": "Maserati Quattroporte", "value": "Quattroporte", "query": "model" },

  { "label": "Maybach 57", "value": "57", "query": "model" },
  { "label": "Maybach 62", "value": "62", "query": "model" },

  { "label": "Mazda 2", "value": "2", "query": "model" },
  { "label": "Mazda 3", "value": "3", "query": "model" },
  { "label": "Mazda 5", "value": "5", "query": "model" },
  { "label": "Mazda 6", "value": "6", "query": "model" },
  { "label": "Mazda 3 Sport", "value": "3 Sport", "query": "model" },
  { "label": "Mazda B2300", "value": "B2300", "query": "model" },
  { "label": "Mazda B4000", "value": "B4000", "query": "model" },
  { "label": "Mazda CX-3", "value": "CX-3", "query": "model" },
  { "label": "Mazda CX-30", "value": "CX-30", "query": "model" },
  { "label": "Mazda CX-5", "value": "CX-5", "query": "model" },
  { "label": "Mazda CX-50", "value": "CX-50", "query": "model" },
  { "label": "Mazda CX-7", "value": "CX-7", "query": "model" },
  { "label": "Mazda CX-9", "value": "CX-9", "query": "model" },
  { "label": "Mazda MX-30 EV", "value": "MX-30 EV", "query": "model" },
  { "label": "Mazda MX-5", "value": "MX-5", "query": "model" },
  { "label": "Mazda MX-5 Miata", "value": "MX-5 Miata", "query": "model" },
  { "label": "Mazda RX-8", "value": "RX-8", "query": "model" },
  { "label": "Mazda Tribute", "value": "Tribute", "query": "model" },
  { "label": "Mazda CX-90", "value": "CX-90", "query": "model" },

  { "label": "McLaren 540C", "value": "540C", "query": "model" },
  { "label": "McLaren 570GT", "value": "570GT", "query": "model" },
  { "label": "McLaren 570S", "value": "570S", "query": "model" },
  { "label": "McLaren 600LT", "value": "600LT", "query": "model" },
  { "label": "McLaren 650S", "value": "650S", "query": "model" },
  { "label": "McLaren 675LT", "value": "675LT", "query": "model" },
  { "label": "McLaren 720S", "value": "720S", "query": "model" },
  { "label": "McLaren 765LT", "value": "765LT", "query": "model" },
  { "label": "McLaren Artura", "value": "Artura", "query": "model" },
  { "label": "McLaren MP4-12C", "value": "MP4-12C", "query": "model" },
  { "label": "McLaren P1", "value": "P1", "query": "model" },

  { "label": "Mercedes-Benz A-Class", "value": "A-Class", "query": "model" },
  { "label": "Mercedes-Benz Allegro", "value": "Allegro", "query": "model" },
  { "label": "Mercedes-Benz Alliado", "value": "Alliado", "query": "model" },
  { "label": "Mercedes-Benz AMG-Class", "value": "AMG-Class", "query": "model" },
  { "label": "Mercedes-Benz Andare", "value": "Andare", "query": "model" },
  { "label": "Mercedes-Benz B Electric Drive", "value": "B Electric Drive", "query": "model" },
  { "label": "Mercedes-Benz B-Class", "value": "B-Class", "query": "model" },
  { "label": "Mercedes-Benz Boxer 40", "value": "Boxer 40", "query": "model" },
  { "label": "Mercedes-Benz Boxer 50", "value": "Boxer 50", "query": "model" },
  { "label": "Mercedes-Benz Boxer 60", "value": "Boxer 60", "query": "model" },
  { "label": "Mercedes-Benz Boxer OF", "value": "Boxer OF", "query": "model" },
  { "label": "Mercedes-Benz Busstar 380", "value": "Busstar 380", "query": "model" },
  { "label": "Mercedes-Benz C-Class", "value": "C-Class", "query": "model" },
  { "label": "Mercedes-Benz CL-Class", "value": "CL-Class", "query": "model" },
  { "label": "Mercedes-Benz CLA-Class", "value": "CLA-Class", "query": "model" },
  { "label": "Mercedes-Benz CLS-Class", "value": "CLS-Class", "query": "model" },
  { "label": "Mercedes-Benz Coraza S2", "value": "Coraza S2", "query": "model" },
  { "label": "Mercedes-Benz E-Class", "value": "E-Class", "query": "model" },
  { "label": "Mercedes-Benz EQA300", "value": "EQA300", "query": "model" },
  { "label": "Mercedes-Benz EQC400", "value": "EQC400", "query": "model" },
  { "label": "Mercedes-Benz FS65", "value": "FS65", "query": "model" },
  { "label": "Mercedes-Benz G-Class", "value": "G-Class", "query": "model" },
  { "label": "Mercedes-Benz GL-Class", "value": "GL-Class", "query": "model" },
  { "label": "Mercedes-Benz GLA-Class", "value": "GLA-Class", "query": "model" },
  { "label": "Mercedes-Benz GLB-Class", "value": "GLB-Class", "query": "model" },
  { "label": "Mercedes-Benz GLC-Class", "value": "GLC-Class", "query": "model" },
  { "label": "Mercedes-Benz GLE-Class", "value": "GLE-Class", "query": "model" },
  { "label": "Mercedes-Benz GLK-Class", "value": "GLK-Class", "query": "model" },
  { "label": "Mercedes-Benz GLS-Class", "value": "GLS-Class", "query": "model" },
  { "label": "Mercedes-Benz Gran Viale", "value": "Gran Viale", "query": "model" },
  { "label": "Mercedes-Benz Gran Viale Articulado", "value": "Gran Viale Articulado", "query": "model" },
  { "label": "Mercedes-Benz Gran Viale LE", "value": "Gran Viale LE", "query": "model" },
  { "label": "Mercedes-Benz Gran Viale RF", "value": "Gran Viale RF", "query": "model" },
  { "label": "Mercedes-Benz HDX", "value": "HDX", "query": "model" },
  { "label": "Mercedes-Benz LO 916", "value": "LO 916", "query": "model" },
  { "label": "Mercedes-Benz Marco Polo", "value": "Marco Polo", "query": "model" },
  { "label": "Mercedes-Benz Maybach GLS600", "value": "Maybach GLS600", "query": "model" },
  { "label": "Mercedes-Benz Maybach S550", "value": "Maybach S550", "query": "model" },
  { "label": "Mercedes-Benz Maybach S560", "value": "Maybach S560", "query": "model" },
  { "label": "Mercedes-Benz Maybach S580", "value": "Maybach S580", "query": "model" },
  { "label": "Mercedes-Benz Maybach S600", "value": "Maybach S600", "query": "model" },
  { "label": "Mercedes-Benz Maybach S650", "value": "Maybach S650", "query": "model" },
  { "label": "Mercedes-Benz Maybach S680", "value": "Maybach S680", "query": "model" },
  { "label": "Mercedes-Benz MBO 1018", "value": "MBO 1018", "query": "model" },
  { "label": "Mercedes-Benz MBO 12000", "value": "MBO 12000", "query": "model" },
  { "label": "Mercedes-Benz MBO 1218", "value": "MBO 1218", "query": "model" },
  { "label": "Mercedes-Benz MBO 1221", "value": "MBO 1221", "query": "model" },
  { "label": "Mercedes-Benz MBO 14000", "value": "MBO 14000", "query": "model" },
  { "label": "Mercedes-Benz MBO 1421", "value": "MBO 1421", "query": "model" },
  { "label": "Mercedes-Benz Metris", "value": "Metris", "query": "model" },
  { "label": "Mercedes-Benz M-Class", "value": "M-Class", "query": "model" },
  { "label": "Mercedes-Benz MP60 Express", "value": "MP60 Express", "query": "model" },
  { "label": "Mercedes-Benz Multego", "value": "Multego", "query": "model" },
  { "label": "Mercedes-Benz O500", "value": "O500", "query": "model" },
  { "label": "Mercedes-Benz OC 500", "value": "OC 500", "query": "model" },
  { "label": "Mercedes-Benz OF 1118", "value": "OF 1118", "query": "model" },
  { "label": "Mercedes-Benz OF 1318", "value": "OF 1318", "query": "model" },
  { "label": "Mercedes-Benz OF 1321", "value": "OF 1321", "query": "model" },
  { "label": "Mercedes-Benz OH 1500", "value": "OH 1500", "query": "model" },
  { "label": "Mercedes-Benz OH 1518", "value": "OH 1518", "query": "model" },
  { "label": "Mercedes-Benz OH 1524", "value": "OH 1524", "query": "model" },
  { "label": "Mercedes-Benz OH 1600", "value": "OH 1600", "query": "model" },
  { "label": "Mercedes-Benz OH 1621", "value": "OH 1621", "query": "model" },
  { "label": "Mercedes-Benz OH 1624", "value": "OH 1624", "query": "model" },
  { "label": "Mercedes-Benz OH 1625", "value": "OH 1625", "query": "model" },
  { "label": "Mercedes-Benz OMC 1400", "value": "OMC 1400", "query": "model" },
  { "label": "Mercedes-Benz Paradiso 1200", "value": "Paradiso 1200", "query": "model" },
  { "label": "Mercedes-Benz Paradiso 1350", "value": "Paradiso 1350", "query": "model" },
  { "label": "Mercedes-Benz Paradiso 1800", "value": "Paradiso 1800", "query": "model" },
  { "label": "Mercedes-Benz R-Class", "value": "R-Class", "query": "model" },
  { "label": "Mercedes-Benz S-Class", "value": "S-Class", "query": "model" },
  { "label": "Mercedes-Benz Safety Bus", "value": "Safety Bus", "query": "model" },
  { "label": "Mercedes-Benz SL-Class", "value": "SL-Class", "query": "model" },
  { "label": "Mercedes-Benz SLC-Class", "value": "SLC-Class", "query": "model" },
  { "label": "Mercedes-Benz SLK-Class", "value": "SLK-Class", "query": "model" },
  { "label": "Mercedes-Benz SLS-Class", "value": "SLS-Class", "query": "model" },
  { "label": "Mercedes-Benz Sprinter", "value": "Sprinter", "query": "model" },
  { "label": "Mercedes-Benz Toreto 45", "value": "Toreto 45", "query": "model" },
  { "label": "Mercedes-Benz Toreto 48", "value": "Toreto 48", "query": "model" },
  { "label": "Mercedes-Benz Torino", "value": "Torino", "query": "model" },
  { "label": "Mercedes-Benz Tres Ejes", "value": "Tres Ejes", "query": "model" },
  { "label": "Mercedes-Benz V220d", "value": "V220d", "query": "model" },
  { "label": "Mercedes-Benz V250", "value": "V250", "query": "model" },
  { "label": "Mercedes-Benz Viaggio 1050", "value": "Viaggio 1050", "query": "model" },
  { "label": "Mercedes-Benz Viaggio 900", "value": "Viaggio 900", "query": "model" },
  { "label": "Mercedes-Benz Viale BRT", "value": "Viale BRT", "query": "model" },
  { "label": "Mercedes-Benz Viano", "value": "Viano", "query": "model" },
  { "label": "Mercedes-Benz Vito", "value": "Vito", "query": "model" },
  { "label": "Mercedes-Benz EQB", "value": "EQB", "query": "model" },
  { "label": "Mercedes-Benz EQE", "value": "EQE", "query": "model" },
  { "label": "Mercedes-Benz EQS", "value": "EQS", "query": "model" },

  { "label": "Mercury Grand Marquis", "value": "Grand Marquis", "query": "model" },
  { "label": "Mercury Mariner", "value": "Mariner", "query": "model" },
  { "label": "Mercury Milan", "value": "Milan", "query": "model" },
  { "label": "Mercury Mountaineer", "value": "Mountaineer", "query": "model" },

  { "label": "Mini Cooper", "value": "Cooper", "query": "model" },
  { "label": "Mini Cooper Clubman", "value": "Cooper Clubman", "query": "model" },
  { "label": "Mini Cooper Countryman", "value": "Cooper Countryman", "query": "model" },
  { "label": "Mini Cooper Paceman", "value": "Cooper Paceman", "query": "model" },
  { "label": "Mini Convertible", "value": "Convertible", "query": "model" },

  { "label": "Mitsubishi ASX", "value": "ASX", "query": "model" },
  { "label": "Mitsubishi Eclipse", "value": "Eclipse", "query": "model" },
  { "label": "Mitsubishi Eclipse Cross", "value": "Eclipse Cross", "query": "model" },
  { "label": "Mitsubishi Endeavor", "value": "Endeavor", "query": "model" },
  { "label": "Mitsubishi Galant", "value": "Galant", "query": "model" },
  { "label": "Mitsubishi i-MiEV", "value": "i-MiEV", "query": "model" },
  { "label": "Mitsubishi L200", "value": "L200", "query": "model" },
  { "label": "Mitsubishi Lancer", "value": "Lancer", "query": "model" },
  { "label": "Mitsubishi Mirage", "value": "Mirage", "query": "model" },
  { "label": "Mitsubishi Mirage G4", "value": "Mirage G4", "query": "model" },
  { "label": "Mitsubishi Montero", "value": "Montero", "query": "model" },
  { "label": "Mitsubishi Montero Sport", "value": "Montero Sport", "query": "model" },
  { "label": "Mitsubishi Outlander", "value": "Outlander", "query": "model" },
  { "label": "Mitsubishi Outlander PHEV", "value": "Outlander PHEV", "query": "model" },
  { "label": "Mitsubishi Outlander Sport", "value": "Outlander Sport", "query": "model" },
  { "label": "Mitsubishi RVR", "value": "RVR", "query": "model" },
  { "label": "Mitsubishi Xpander", "value": "Xpander", "query": "model" },

  { "label": "Nissan 370Z", "value": "370Z", "query": "model" },
  { "label": "Nissan Altima", "value": "Altima", "query": "model" },
  { "label": "Nissan Aprio", "value": "Aprio", "query": "model" },
  { "label": "Nissan Ariya", "value": "Ariya", "query": "model" },
  { "label": "Nissan Armada", "value": "Armada", "query": "model" },
  { "label": "Nissan Cabstar", "value": "Cabstar", "query": "model" },
  { "label": "Nissan Cube", "value": "Cube", "query": "model" },
  { "label": "Nissan Frontier", "value": "Frontier", "query": "model" },
  { "label": "Nissan GT-R", "value": "GT-R", "query": "model" },
  { "label": "Nissan Juke", "value": "Juke", "query": "model" },
  { "label": "Nissan Kicks", "value": "Kicks", "query": "model" },
  { "label": "Nissan Kicks e-Power", "value": "Kicks e-Power", "query": "model" },
  { "label": "Nissan Leaf", "value": "Leaf", "query": "model" },
  { "label": "Nissan March", "value": "March", "query": "model" },
  { "label": "Nissan Maxima", "value": "Maxima", "query": "model" },
  { "label": "Nissan Micra", "value": "Micra", "query": "model" },
  { "label": "Nissan Murano", "value": "Murano", "query": "model" },
  { "label": "Nissan Note", "value": "Note", "query": "model" },
  { "label": "Nissan NP 300", "value": "NP 300", "query": "model" },
  { "label": "Nissan NP 300 Frontier", "value": "NP 300 Frontier", "query": "model" },
  { "label": "Nissan NT 400 Cabstar", "value": "NT 400 Cabstar", "query": "model" },
  { "label": "Nissan NV 1500", "value": "NV 1500", "query": "model" },
  { "label": "Nissan NV 200", "value": "NV 200", "query": "model" },
  { "label": "Nissan NV 2500", "value": "NV 2500", "query": "model" },
  { "label": "Nissan NV 350 Urvan", "value": "NV 350 Urvan", "query": "model" },
  { "label": "Nissan NV 3500", "value": "NV 3500", "query": "model" },
  { "label": "Nissan Pathfinder", "value": "Pathfinder", "query": "model" },
  { "label": "Nissan Pickup", "value": "Pickup", "query": "model" },
  { "label": "Nissan Platina", "value": "Platina", "query": "model" },
  { "label": "Nissan Qashqai", "value": "Qashqai", "query": "model" },
  { "label": "Nissan Quest", "value": "Quest", "query": "model" },
  { "label": "Nissan Rogue", "value": "Rogue", "query": "model" },
  { "label": "Nissan Rogue Select", "value": "Rogue Select", "query": "model" },
  { "label": "Nissan Rogue Sport", "value": "Rogue Sport", "query": "model" },
  { "label": "Nissan Sentra", "value": "Sentra", "query": "model" },
  { "label": "Nissan Tiida", "value": "Tiida", "query": "model" },
  { "label": "Nissan Titan", "value": "Titan", "query": "model" },
  { "label": "Nissan Titan XD", "value": "Titan XD", "query": "model" },
  { "label": "Nissan Tsuru", "value": "Tsuru", "query": "model" },
  { "label": "Nissan Urvan", "value": "Urvan", "query": "model" },
  { "label": "Nissan V-Drive", "value": "V-Drive", "query": "model" },
  { "label": "Nissan Versa", "value": "Versa", "query": "model" },
  { "label": "Nissan Versa Note", "value": "Versa Note", "query": "model" },
  { "label": "Nissan X-Trail", "value": "X-Trail", "query": "model" },
  { "label": "Nissan Xterra", "value": "Xterra", "query": "model" },
  { "label": "Nissan Z", "value": "Z", "query": "model" },

  { "label": "Porsche 911", "value": "911", "query": "model" },
  { "label": "Porsche 718 Boxster", "value": "718 Boxster", "query": "model" },
  { "label": "Porsche 718 Cayman", "value": "718 Cayman", "query": "model" },
  { "label": "Porsche 718 Spyder", "value": "718 Spyder", "query": "model" },
  { "label": "Porsche 918 Spyder", "value": "918 Spyder", "query": "model" },
  { "label": "Porsche Boxster", "value": "Boxster", "query": "model" },
  { "label": "Porsche Cayenne", "value": "Cayenne", "query": "model" },
  { "label": "Porsche Cayman", "value": "Cayman", "query": "model" },
  { "label": "Porsche Macan", "value": "Macan", "query": "model" },
  { "label": "Porsche Panamera", "value": "Panamera", "query": "model" },
  { "label": "Porsche Taycan", "value": "Taycan", "query": "model" },

  { "label": "Ram 700", "value": "700", "query": "model" },
  { "label": "Ram 1500", "value": "1500", "query": "model" },
  { "label": "Ram 2500", "value": "2500", "query": "model" },
  { "label": "Ram 3500", "value": "3500", "query": "model" },
  { "label": "Ram 4000", "value": "4000", "query": "model" },
  { "label": "Ram 4500", "value": "4500", "query": "model" },
  { "label": "Ram 5500", "value": "5500", "query": "model" },
  { "label": "Ram 1500 Classic", "value": "1500 Classic", "query": "model" },
  { "label": "Ram DAKOTA", "value": "DAKOTA", "query": "model" },
  { "label": "Ram C/V", "value": "C/V", "query": "model" },
  { "label": "Ram ProMaster 1500", "value": "ProMaster 1500", "query": "model" },
  { "label": "Ram ProMaster 2500", "value": "ProMaster 2500", "query": "model" },
  { "label": "Ram ProMaster 3500", "value": "ProMaster 3500", "query": "model" },
  { "label": "Ram ProMaster City", "value": "ProMaster City", "query": "model" },
  { "label": "Ram ProMaster Rapid", "value": "ProMaster Rapid", "query": "model" },

  { "label": "Rolls-Royce Cullinan", "value": "Cullinan", "query": "model" },
  { "label": "Rolls-Royce Dawn", "value": "Dawn", "query": "model" },
  { "label": "Rolls-Royce Ghost", "value": "Ghost", "query": "model" },
  { "label": "Rolls-Royce Phantom", "value": "Phantom", "query": "model" },
  { "label": "Rolls-Royce Wraith", "value": "Wraith", "query": "model" },

  { "label": "Saab 9-3", "value": "9-3", "query": "model" },
  { "label": "Saab 9-3X", "value": "9-3X", "query": "model" },
  { "label": "Saab 9-4", "value": "9-4", "query": "model" },
  { "label": "Saab 9-4X", "value": "9-4X", "query": "model" },
  { "label": "Saab 9-5X", "value": "9-5X", "query": "model" },
  { "label": "Saab 9-5", "value": "9-5", "query": "model" },

  { "label": "Scion FR-S", "value": "FR-S", "query": "model" },
  { "label": "Scion iA", "value": "iA", "query": "model" },
  { "label": "Scion iM", "value": "iM", "query": "model" },
  { "label": "Scion iQ", "value": "iQ", "query": "model" },
  { "label": "Scion tC", "value": "tC", "query": "model" },
  { "label": "Scion xB", "value": "xB", "query": "model" },
  { "label": "Scion xD", "value": "xD", "query": "model" },

  { "label": "Smart EQ fortwo", "value": "EQ fortwo", "query": "model" },
  { "label": "Smart Forfour", "value": "Forfour", "query": "model" },
  { "label": "Smart Fortwo", "value": "Fortwo", "query": "model" },

  { "label": "Subaru Ascent", "value": "Ascent", "query": "model" },
  { "label": "Subaru BRZ", "value": "BRZ", "query": "model" },
  { "label": "Subaru Crosstrek", "value": "Crosstrek", "query": "model" },
  { "label": "Subaru Forester", "value": "Forester", "query": "model" },
  { "label": "Subaru Impreza", "value": "Impreza", "query": "model" },
  { "label": "Subaru Legacy", "value": "Legacy", "query": "model" },
  { "label": "Subaru Outback", "value": "Outback", "query": "model" },
  { "label": "Subaru Solterra", "value": "Solterra", "query": "model" },
  { "label": "Subaru Tribeca", "value": "Tribeca", "query": "model" },
  { "label": "Subaru WRX", "value": "WRX", "query": "model" },
  { "label": "Subaru WRX STI", "value": "WRX STI", "query": "model" },
  { "label": "Subaru XV", "value": "XV", "query": "model" },
  { "label": "Subaru XV Crosstrek", "value": "XV Crosstrek", "query": "model" },

  { "label": "Suzuki Baleno", "value": "Baleno", "query": "model" },
  { "label": "Suzuki Ciaz", "value": "Ciaz", "query": "model" },
  { "label": "Suzuki Equator", "value": "Equator", "query": "model" },
  { "label": "Suzuki Ertiga", "value": "Ertiga", "query": "model" },
  { "label": "Suzuki Grand Vitara", "value": "Grand Vitara", "query": "model" },
  { "label": "Suzuki Ignis", "value": "Ignis", "query": "model" },
  { "label": "Suzuki Jimny", "value": "Jimny", "query": "model" },
  { "label": "Suzuki Kizashi", "value": "Kizashi", "query": "model" },
  { "label": "Suzuki S-Cross", "value": "S-Cross", "query": "model" },
  { "label": "Suzuki Swift", "value": "Swift", "query": "model" },
  { "label": "Suzuki Swift+", "value": "Swift+", "query": "model" },
  { "label": "Suzuki SX4", "value": "SX4", "query": "model" },
  { "label": "Suzuki SX4 Crossover", "value": "SX4 Crossover", "query": "model" },
  { "label": "Suzuki Vitara", "value": "Vitara", "query": "model" },

  { "label": "Tesla Model 3", "value": "Model 3", "query": "model" },
  { "label": "Tesla Roadster", "value": "Roadster", "query": "model" },
  { "label": "Tesla Model S", "value": "Model S", "query": "model" },
  { "label": "Tesla Model X", "value": "Model X", "query": "model" },
  { "label": "Tesla Model Y", "value": "Model Y", "query": "model" },

  { "label": "Toyota 86", "value": "86", "query": "model" },
  { "label": "Toyota 4Runner", "value": "4Runner", "query": "model" },
  { "label": "Toyota Avalon", "value": "Avalon", "query": "model" },
  { "label": "Toyota Avanza", "value": "Avanza", "query": "model" },
  { "label": "Toyota bZ4X", "value": "bZ4X", "query": "model" },
  { "label": "Toyota C-HR", "value": "C-HR", "query": "model" },
  { "label": "Toyota Camry", "value": "Camry", "query": "model" },
  { "label": "Toyota Corolla", "value": "Corolla", "query": "model" },
  { "label": "Toyota Corolla Cross", "value": "Corolla Cross", "query": "model" },
  { "label": "Toyota Corolla iM", "value": "Corolla iM", "query": "model" },
  { "label": "Toyota FJ Cruiser", "value": "FJ Cruiser", "query": "model" },
  { "label": "Toyota GR 86", "value": "GR 86", "query": "model" },
  { "label": "Toyota GR Corolla", "value": "GR Corolla", "query": "model" },
  { "label": "Toyota GR Supra", "value": "GR Supra", "query": "model" },
  { "label": "Toyota GR86", "value": "GR86", "query": "model" },
  { "label": "Toyota Hiace", "value": "Hiace", "query": "model" },
  { "label": "Toyota Highlander", "value": "Highlander", "query": "model" },
  { "label": "Toyota Hilux", "value": "Hilux", "query": "model" },
  { "label": "Toyota Land Cruiser", "value": "Land Cruiser", "query": "model" },
  { "label": "Toyota Matrix", "value": "Matrix", "query": "model" },
  { "label": "Toyota Mirai", "value": "Mirai", "query": "model" },
  { "label": "Toyota Prius", "value": "Prius", "query": "model" },
  { "label": "Toyota Prius AWD-e", "value": "Prius AWD-e", "query": "model" },
  { "label": "Toyota Prius C", "value": "Prius C", "query": "model" },
  { "label": "Toyota Prius Plug-In", "value": "Prius Plug-In", "query": "model" },
  { "label": "Toyota Prius Prime", "value": "Prius Prime", "query": "model" },
  { "label": "Toyota Prius V", "value": "Prius V", "query": "model" },
  { "label": "Toyota Raize", "value": "Raize", "query": "model" },
  { "label": "Toyota RAV4", "value": "RAV4", "query": "model" },
  { "label": "Toyota RAV4 Prime", "value": "RAV4 Prime", "query": "model" },
  { "label": "Toyota Sequoia", "value": "Sequoia", "query": "model" },
  { "label": "Toyota Sienna", "value": "Sienna", "query": "model" },
  { "label": "Toyota SCION", "value": "SCION", "query": "model" },
  { "label": "Toyota SCION FR-S", "value": "SCION FR-S", "query": "model" },
  { "label": "Toyota Supra", "value": "Supra", "query": "model" },
  { "label": "Toyota Tacoma", "value": "Tacoma", "query": "model" },
  { "label": "Toyota Tundra", "value": "Tundra", "query": "model" },
  { "label": "Toyota Venza", "value": "Venza", "query": "model" },
  { "label": "Toyota Yaris", "value": "Yaris", "query": "model" },
  { "label": "Toyota Yaris iA", "value": "Yaris iA", "query": "model" },
  { "label": "Toyota Yaris R", "value": "Yaris R", "query": "model" },
  { "label": "Toyota Crown", "value": "Crown", "query": "model" },

  { "label": "Volkswagen Amarok", "value": "Amarok", "query": "model" },
  { "label": "Volkswagen Arteon", "value": "Arteon", "query": "model" },
  { "label": "Volkswagen Atlas", "value": "Atlas", "query": "model" },
  { "label": "Volkswagen Atlas Cross Sport", "value": "Atlas Cross Sport", "query": "model" },
  { "label": "Volkswagen Beetle", "value": "Beetle", "query": "model" },
  { "label": "Volkswagen Beetle Cabrio", "value": "Beetle Cabrio", "query": "model" },
  { "label": "Volkswagen Bora", "value": "Bora", "query": "model" },
  { "label": "Volkswagen Caddy", "value": "Caddy", "query": "model" },
  { "label": "Volkswagen CC", "value": "CC", "query": "model" },
  { "label": "Volkswagen Clasico", "value": "Clasico", "query": "model" },
  { "label": "Volkswagen Combi", "value": "Combi", "query": "model" },
  { "label": "Volkswagen Constellation", "value": "Constellation", "query": "model" },
  { "label": "Volkswagen Crafter", "value": "Crafter", "query": "model" },
  { "label": "Volkswagen Crafter Van", "value": "Crafter Van", "query": "model" },
  { "label": "Volkswagen Cross Sport", "value": "Cross Sport", "query": "model" },
  { "label": "Volkswagen CrossFox", "value": "CrossFox", "query": "model" },
  { "label": "Volkswagen Delivery", "value": "Delivery", "query": "model" },
  { "label": "Volkswagen e-Golf", "value": "e-Golf", "query": "model" },
  { "label": "Volkswagen Eos", "value": "Eos", "query": "model" },
  { "label": "Volkswagen GLI", "value": "GLI", "query": "model" },
  { "label": "Volkswagen Gol", "value": "Gol", "query": "model" },
  { "label": "Volkswagen Gol Sedan", "value": "Gol Sedan", "query": "model" },
  { "label": "Volkswagen Golf", "value": "Golf", "query": "model" },
  { "label": "Volkswagen Golf Alltrack", "value": "Golf Alltrack", "query": "model" },
  { "label": "Volkswagen Golf City", "value": "Golf City", "query": "model" },
  { "label": "Volkswagen Golf R", "value": "Golf R", "query": "model" },
  { "label": "Volkswagen Golf SportWagen", "value": "Golf SportWagen", "query": "model" },
  { "label": "Volkswagen GTI", "value": "GTI", "query": "model" },
  { "label": "Volkswagen ID.4", "value": "ID.4", "query": "model" },
  { "label": "Volkswagen Jetta", "value": "Jetta", "query": "model" },
  { "label": "Volkswagen Multivan", "value": "Multivan", "query": "model" },
  { "label": "Volkswagen Nivus", "value": "Nivus", "query": "model" },
  { "label": "Volkswagen Nuevo Gol", "value": "Nuevo Gol", "query": "model" },
  { "label": "Volkswagen Passat", "value": "Passat", "query": "model" },
  { "label": "Volkswagen Passat CC", "value": "Passat CC", "query": "model" },
  { "label": "Volkswagen Pointer Truck", "value": "Pointer Truck", "query": "model" },
  { "label": "Volkswagen Polo", "value": "Polo", "query": "model" },
  { "label": "Volkswagen Robust", "value": "Robust", "query": "model" },
  { "label": "Volkswagen Routan", "value": "Routan", "query": "model" },
  { "label": "Volkswagen Saveiro", "value": "Saveiro", "query": "model" },
  { "label": "Volkswagen SportVan", "value": "SportVan", "query": "model" },
  { "label": "Volkswagen T-Cross", "value": "T-Cross", "query": "model" },
  { "label": "Volkswagen Taos", "value": "Taos", "query": "model" },
  { "label": "Volkswagen Teramont", "value": "Teramont", "query": "model" },
  { "label": "Volkswagen Tiguan", "value": "Tiguan", "query": "model" },
  { "label": "Volkswagen Tiguan Limited", "value": "Tiguan Limited", "query": "model" },
  { "label": "Volkswagen Touareg", "value": "Touareg", "query": "model" },
  { "label": "Volkswagen Transporter", "value": "Transporter", "query": "model" },
  { "label": "Volkswagen Up!", "value": "Up!", "query": "model" },
  { "label": "Volkswagen Vento", "value": "Vento", "query": "model" },
  { "label": "Volkswagen Virtus", "value": "Virtus", "query": "model" },
  { "label": "Volkswagen Volksbus", "value": "Volksbus", "query": "model" },
  { "label": "Volkswagen Worker", "value": "Worker", "query": "model" },
  { "label": "Volkswagen Workline", "value": "Workline", "query": "model" },
  { "label": "Volkswagen Vanagon", "value": "Vanagon", "query": "model" },

  { "label": "Volvo 7900", "value": "7900", "query": "model" },
  { "label": "Volvo 8300", "value": "8300", "query": "model" },
  { "label": "Volvo 9700", "value": "9700", "query": "model" },
  { "label": "Volvo 9800", "value": "9800", "query": "model" },
  { "label": "Volvo 7300 BRT", "value": "7300 BRT", "query": "model" },
  { "label": "Volvo 9700 Grand", "value": "9700 Grand", "query": "model" },
  { "label": "Volvo Access", "value": "Access", "query": "model" },
  { "label": "Volvo ALD Enviro500", "value": "ALD Enviro500", "query": "model" },
  { "label": "Volvo B11R", "value": "B11R", "query": "model" },
  { "label": "Volvo B13R", "value": "B13R", "query": "model" },
  { "label": "Volvo B290R", "value": "B290R", "query": "model" },
  { "label": "Volvo B410R", "value": "B410R", "query": "model" },
  { "label": "Volvo B8R", "value": "B8R", "query": "model" },
  { "label": "Volvo B8RLE", "value": "B8RLE", "query": "model" },
  { "label": "Volvo C30", "value": "C30", "query": "model" },
  { "label": "Volvo C40", "value": "C40", "query": "model" },
  { "label": "Volvo C70", "value": "C70", "query": "model" },
  { "label": "Volvo Hibrido", "value": "Hibrido", "query": "model" },
  { "label": "Volvo ProCity", "value": "ProCity", "query": "model" },
  { "label": "Volvo S40", "value": "S40", "query": "model" },
  { "label": "Volvo S60", "value": "S60", "query": "model" },
  { "label": "Volvo S60 Cross Country", "value": "S60 Cross Country", "query": "model" },
  { "label": "Volvo S80", "value": "S80", "query": "model" },
  { "label": "Volvo S90", "value": "S90", "query": "model" },
  { "label": "Volvo V40", "value": "V40", "query": "model" },
  { "label": "Volvo V40 Cross Country", "value": "V40 Cross Country", "query": "model" },
  { "label": "Volvo V50", "value": "V50", "query": "model" },
  { "label": "Volvo V60", "value": "V60", "query": "model" },
  { "label": "Volvo V60 Cross Country", "value": "V60 Cross Country", "query": "model" },
  { "label": "Volvo V70", "value": "V70", "query": "model" },
  { "label": "Volvo V90", "value": "V90", "query": "model" },
  { "label": "Volvo V90 Cross Country", "value": "V90 Cross Country", "query": "model" },
  { "label": "Volvo VAH", "value": "VAH", "query": "model" },
  { "label": "Volvo VAH 300", "value": "VAH 300", "query": "model" },
  { "label": "Volvo VAH 400", "value": "VAH 400", "query": "model" },
  { "label": "Volvo VAH 430", "value": "VAH 430", "query": "model" },
  { "label": "Volvo VAH 640", "value": "VAH 640", "query": "model" },
  { "label": "Volvo VHD", "value": "VHD", "query": "model" },
  { "label": "Volvo VNL", "value": "VNL", "query": "model" },
  { "label": "Volvo VNL 300", "value": "VNL 300", "query": "model" },
  { "label": "Volvo VNL 400", "value": "VNL 400", "query": "model" },
  { "label": "Volvo VNL 430", "value": "VNL 430", "query": "model" },
  { "label": "Volvo VNL 630", "value": "VNL 630", "query": "model" },
  { "label": "Volvo VNL 670", "value": "VNL 670", "query": "model" },
  { "label": "Volvo VNL 740", "value": "VNL 740", "query": "model" },
  { "label": "Volvo VNL 760", "value": "VNL 760", "query": "model" },
  { "label": "Volvo VNL 860", "value": "VNL 860", "query": "model" },
  { "label": "Volvo VNM", "value": "VNM", "query": "model" },
  { "label": "Volvo VNR", "value": "VNR", "query": "model" },
  { "label": "Volvo VNR 300", "value": "VNR 300", "query": "model" },
  { "label": "Volvo VNR 400", "value": "VNR 400", "query": "model" },
  { "label": "Volvo VNR 640", "value": "VNR 640", "query": "model" },
  { "label": "Volvo VNX", "value": "VNX", "query": "model" },
  { "label": "Volvo VT", "value": "VT", "query": "model" },
  { "label": "Volvo XC40", "value": "XC40", "query": "model" },
  { "label": "Volvo XC40 Recharge", "value": "XC40 Recharge", "query": "model" },
  { "label": "Volvo XC60 Recharge", "value": "XC60 Recharge", "query": "model" },
  { "label": "Volvo XC60", "value": "XC60", "query": "model" },
  { "label": "Volvo XC70", "value": "XC70", "query": "model" },
  { "label": "Volvo XC90", "value": "XC90", "query": "model" },
  { "label": "Volvo XC90 Recharge", "value": "XC90 Recharge", "query": "model" }

  ]

